// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'walkie';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <rect width='8' height='14' x='5' y='3' rx='2' />
    <rect width='4' height='4' x='7' y='5' rx='1' />
    <path d='M11.5 1v2m-7 4v2M7 12.5h4m-4 2h4' />
  </g>
);

export const viewBox = '0 0 18 18';
